import styled, { css, keyframes } from "styled-components";
import * as styles from "../../../styleguide/styles/Stylesheet.js";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
 `;

export const LoadingSpinnerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${styles.color_white};
`;

export const LoadingSpinner = styled.div`
  width: 22px;
  height: 22px;
  border: 3px solid ${styles.color_gry_2};
  border-top-color: ${styles.color_accent};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const PageContainer = styled.div`
  width: 100%;
`;

export const GradientSection = styled.div`
  transition: color 250ms ease, background-color 250ms ease,
    border-color 250ms ease;

  [data-day="true"] & {
    --card-bg: rgba(255, 255, 255, 0.6);
    --border: rgba(0, 0, 0, 0.08);
  }

  [data-day="false"] & {
    --card-bg: rgba(10, 15, 32, 0.6);
    --border: rgba(255, 255, 255, 0.06);
  }
`;

export const InteractionsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 58px ${styles.spacing_standard} ${styles.spacing_standard};

  @media only screen and (max-width: ${styles.width_sm}) {
    padding: ${styles.spacing_standard} ${styles.spacing_standard};
  }
`;

export const VictoryContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 ${styles.spacing_standard};
`;

export const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 ${styles.spacing_standard_large};

  @media only screen and (max-width: ${styles.width_sm}) {
    padding: 0 0 ${styles.spacing_standard};
  }
`;

export const IntelWrapper = styled.div`
  width: 100%;
  max-width: ${styles.width_sm};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  background-color: ${styles.color_white};
  margin-top: ${styles.spacing_standard_large};
  padding: ${styles.spacing_standard};

  @media only screen and (max-width: ${styles.width_sm}) {
    margin-top: ${styles.spacing_standard};
  }
`;

export const SectionContainer = styled.div`
  padding: ${styles.spacing_standard_large} 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${styles.color_accent};
  background-color: ${styles.color_white};
  margin-top: ${styles.spacing_standard_large};

  @media only screen and (max-width: ${styles.width_sm}) {
    margin-top: ${styles.spacing_standard};
  }
`;

export const CharactersGridEl = styled.div`
  width: 100%;
  max-width: 1600px;
  padding: ${styles.spacing_standard_large} ${styles.spacing_standard};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${styles.spacing_standard};
  [data-list="true"] & {
    align-items: center;
    flex-direction: column;
    flex-wrap: nowrap;
  }
`;

export const AbilityWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${styles.spacing_standard} 0;
  gap: ${styles.spacing_standard_half};

  @media only screen and (max-width: ${styles.width_sm}) {
    padding: ${styles.spacing_standard_half} 0;
  }
`;

export const AbilityText = styled.div`
  width: 100%;
  text-align: center;
  font-family: ${styles.font_sans};
  font-size: 24px;
  font-weight: bold;
  line-height: 1.4;
  color: ${styles.color_white};
  transition: color 250ms ease;
  [data-day="true"] & {
    color: ${styles.color_accent};
  }
`;

export const AbilityWarning = styled.div`
  width: 100%;
  text-align: center;
  font-family: ${styles.font_sans};
  font-size: 24px;
  font-weight: bold;
  line-height: 1.4;
  color: ${styles.color_red};
`;

export const InformationText = styled.div`
  width: 100%;
  text-align: center;
  font-family: ${styles.font_sans};
  font-size: 18px;
  line-height: 1.4;
  color: ${styles.color_white};
  transition: color 250ms ease;
  margin: 0 0 ${styles.spacing_standard_half};
  [data-day="true"] & {
    color: ${styles.color_accent};
  }
`;

export const AbilityVotingCards = styled.div`
  width: 100%;
  max-width: ${styles.width_lg};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: ${styles.spacing_standard_half} 0 0;
  gap: ${styles.spacing_standard_half};
`;

export const VotingCardContainer = styled.div`
  position: relative;
  display: inline-flex;
`;

export const VotingCard = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: ${styles.spacing_standard_half};
  border-radius: 5px;
  box-shadow: ${styles.box_shadow};
  padding: ${styles.spacing_standard};
  font-family: ${styles.font_sans};
  font-size: 18px;
  font-weight: bold;
  color: ${styles.color_accent};
  background-color: ${styles.color_white};
  line-height: 1.4;
  cursor: pointer;
  ${({ selected }) =>
    selected &&
    css`
      color: ${styles.color_white};
      background-color: ${styles.color_accent};
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.8;
      pointer-events: none;
      cursor: default;
    `}
`;

export const Badge = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -8px;
  right: -8px;
  min-width: 24px;
  height: 24px;
  border-radius: 999px;
  background: ${styles.color_white};
  color: ${styles.color_accent};
  font-size: 16px;
  font-weight: ${styles.font_bold};
  font-family: ${styles.font_sans};
  line-height: 1;
  z-index: 1;
  box-shadow: ${styles.box_shadow};
`;

/* Full-screen overlay */
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${styles.spacing_standard};
  cursor: pointer;
`;

export const OverlayInner = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 720px;
  max-height: 90vh;
  background: ${styles.color_white};
  border-radius: 12px;
  cursor: default;

  @media only screen and (max-width: ${styles.width_sm}) {
    max-height: 80vh;
  }

  @media only screen and (max-width: ${styles.width_nrw}) {
    max-width: 480px;
  }

  ${({ padding }) =>
    padding &&
    css`
      background: none;
    `}
`;

export const PopupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-height: 90vh;
  gap: ${styles.spacing_standard};
  padding: ${styles.spacing_standard};
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;

  @media only screen and (max-width: ${styles.width_sm}) {
    max-height: 80vh;
  }

  ${({ $column }) =>
    $column &&
    css`
      flex-direction: column;
    `}

  @media only screen and (max-width: ${styles.width_nrw}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const PopupResults = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const WinnerPopupResults = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 500px;
  height: 100%;
  max-height: 400px;
`;

export const PopupRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${styles.spacing_standard};
`;

export const CloseX = styled.button`
  appearance: none;
  position: absolute;
  top: -16px;
  right: -16px;
  border: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${styles.color_white};
  font-size: 32px;
  cursor: pointer;
  font-family: ${styles.font_sans};
  font-weight: ${styles.font_bold};
  color: ${styles.color_accent};
  box-shadow: ${styles.box_shadow};
  z-index: 1;
`;

export const ChatRoomContainer = styled.div`
  width: 100%;
  max-width: ${styles.width_nrw};
  margin: ${styles.spacing_standard_large} 0 0;
  border-radius: 10px;
  background: ${styles.color_white};
  display: flex;
  flex-direction: column;
  box-shadow: ${styles.box_shadow};
  overflow: hidden;

  @media only screen and (max-width: ${styles.width_sm}) {
    margin: ${styles.spacing_standard} 0 0;
  }
`;

export const ChatRoomHeader = styled.div`
  display: flex;
  flex-direction: row;
  box-shadow: ${styles.box_shadow};
`;

export const ChatRoomTab = styled.div`
  width: 100%;
  padding: ${styles.spacing_standard} ${styles.spacing_standard_half};
  border-bottom: 3px solid ${styles.color_white};
  font-family: ${styles.font_sans};
  font-weight: ${styles.font_bold};
  line-height: 1;
  color: ${styles.color_accent};
  font-size: 28px;
  text-align: center;

  @media only screen and (max-width: ${styles.width_sm}) {
    font-size: 22px;
  }

  ${({ selected }) =>
    selected &&
    css`
      border-bottom: 3px solid ${styles.color_primary};
    `}

  ${({ selectable }) =>
    selectable &&
    css`
      cursor: pointer;
    `}
`;

export const ChatRoomMessages = styled.div`
  height: 186px;
  overflow: auto;
  padding: ${styles.spacing_standard};
  display: flex;
  flex-direction: column;
  gap: ${styles.spacing_standard_half};
`;

export const ChatRoomMessageRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ChatRoomInputRow = styled.div`
  display: flex;
  gap: ${styles.spacing_standard_half};
  padding: ${styles.spacing_standard};
  box-shadow: ${styles.box_shadow};

  @media only screen and (max-width: ${styles.width_sm}) {
    padding: ${styles.spacing_standard_half};
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 120px;
  display: flex;
  flex-direction: column;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${styles.spacing_standard};
  gap: ${styles.spacing_standard_half};
`;

export const PhaseTag = styled.div`
  padding: 8px 12px;
  border-radius: 5px;
  margin: 0 0 ${styles.spacing_standard};
  font-family: ${styles.font_sans};
  font-size: 16px;
  line-height: 1;
  background-color: ${(p) => (p.$isDay ? "#87c5ff" : styles.color_accent)};
  color: ${styles.color_white};
  text-transform: uppercase;
  font-weight: ${styles.font_bold};

  @media only screen and (max-width: ${styles.width_sm}) {
    margin: 0 0 ${styles.spacing_standard_half};
  }
`;

export const WinnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: ${styles.color_white};
  max-height: 90vh;
  overflow: hidden;

  @media only screen and (max-width: ${styles.width_sm}) {
    max-height: 80vh;
  }
`;

export const WinnerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${styles.spacing_standard};
  box-shadow: ${styles.box_shadow};
`;

export const DonationsSticky = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 1;
`;

export const DonationsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${styles.spacing_standard};
  box-shadow: ${styles.box_shadow};
  background-color: ${styles.color_white};
`;

export const DonationsCopy = styled.div`
  font-family: ${styles.font_sans};
  font-size: 16px;
  color: ${styles.color_accent};
  text-align: center;
`;

export const DonationsButtons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${styles.spacing_standard_half};
  margin: ${styles.spacing_standard_half} 0;
`;

export const DonationButton = styled.div`
  text-align: center;
  font-family: ${styles.font_sans};
  font-size: 14px;
  font-weight: ${styles.font_bold};
  color: ${styles.color_accent};
  line-height: 1.4;
  border-radius: 5px;
  padding: 6px 10px;
  text-decoration: none;
  border: 2px solid ${styles.color_accent};
  cursor: pointer;
  transition: 250ms all;

  &&:hover {
    color: ${styles.color_white};
    background-color: ${styles.color_accent};
  }
`;

export const WinnerList = styled.div`
  width: 100%;
  padding: ${styles.spacing_standard};
  overflow-y: auto;
`;

export const SpectatorWrapper = styled.div`
  width: 100%;
  max-width: ${styles.width_sm};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const PlayerList = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${styles.spacing_standard_half};
`;

export const PlayerCard = styled.div`
  width: 100%;
  max-width: ${styles.width_nrw};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${styles.spacing_standard};
  background-color: ${styles.color_white};
  border-radius: 10px;
  box-shadow: ${styles.box_shadow};
  padding: ${styles.spacing_standard_half};
`;

export const CharacterTag = styled.div`
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 6px 8px;
  font-size: 14px;
  font-family: ${styles.font_sans};
  font-weight: ${styles.font_bold};
  color: ${styles.color_white};
  text-transform: uppercase;
  background-color: ${(p) => p.$bg || styles.color_white};

  ${({ listView }) =>
    listView &&
    css`
      margin-bottom: 0px;
    `}
`;
